export const wongnai ={
 "้าน": 134642,
 "ร้า": 119805,
 "ที่": 118052,
 "ไม่": 102900,
 "่อย": 82040,
 "ได้": 73344,
 "นี้": 72915,
 "มาก": 69226,
 "เป็": 66661,
 "แต่": 66436,
 "ป็น": 62878,
 "เลย": 62262,
 "ว่า": 59965,
 "ค่ะ": 57345,
 "ข้า": 53751,
 "ั่ง": 51812,
 "รับ": 51245,
 "ร่อ": 50937,
 "อร่": 50575,
 "นนี": 48245,
 "หาร": 44594,
 "ครั": 44076,
 "าหา": 43952,
 "และ": 43314,
 "อาห": 43283,
 "ื่อ": 41649,
 "ให้": 41496,
 "น้ำ": 40458,
 "ทาน": 40247,
 "่าง": 38617,
 "านน": 38492,
 "กับ": 36438,
 "กิน": 36003,
 "รสช": 35471,
 "ล้ว": 35365,
 "สชา": 35276,
 "ของ": 35186,
 "ั้ง": 34933,
 "ชาต": 34190,
 "าติ": 33899,
 "แล้": 33152,
 "อยู": 32336,
 "้วย": 32308,
 "ยู่": 32223,
 "้อง": 31843,
 "เมน": 31779,
 "การ": 31151,
 "มนู": 30950,
 "ย่า": 30913,
 "กัน": 30800,
 "สั่": 30339,
 "???": 30307,
 "ด้ว": 29157,
 "ื้อ": 29021,
 "าคา": 28663,
 "ราค": 27960,
 "่อน": 26289,
 "้าว": 25755,
 "ยาก": 24183,
 "หมู": 23984,
 "านเ": 23774,
 "ียว": 23693,
 "เนื": 23184,
 "แบบ": 23103,
 "อย่": 22898,
 "นที": 22639,
 "่อง": 22620,
 "เข้": 22547,
 "วัน": 22516,
 "ต้อ": 22419,
 "วาน": 21904,
 "้าง": 21503,
 "หลา": 21408,
 "หวา": 21288,
 "นร้": 21004,
 "ยอะ": 20834,
 "นื้": 20642,
 "่วน": 20595,
 "นมา": 20579,
 "เยอ": 20546,
 "ปลา": 20333,
 "กว่": 20125,
 "ชอบ": 20084,
 "ส่ว": 19653,
 "บาท": 19618,
 "ตัว": 19577,
 "มือ": 19356,
 "เรา": 19208,
 "รื่": 19138,
 "ลอง": 19138,
 "ลือ": 18950,
 "ริก": 18646,
 "ั้น": 18539,
 "่าน": 18457,
 "ลาย": 18447,
 "นั่": 18424,
 "ันน": 18413,
 "อีก": 18339,
 "เพร": 18335,
 "านอ": 18248,
 "เหม": 18175,
 "คือ": 18149,
 "พรา": 18139,
 "ี่เ": 17985,
 "มัน": 17676,
 "จาก": 17591,
 "งร้": 17424,
 "ประ": 17260,
 "ราะ": 17160,
 "น้า": 17015,
 "ือก": 16304,
 "นะค": 16293,
 "ะมา": 16291,
 "นี่": 16138,
 "ี่น": 16108,
 "วาม": 16103,
 "หน้": 16017,
 "ทั้": 15859,
 "ทาง": 15776,
 "ยัง": 15711,
 "น่า": 15668,
 "ิ่ม": 15641,
 "ือน": 15599,
 "ามา": 15583,
 "ม่เ": 15392,
 "ควา": 15378,
 "้เล": 15331,
 "ถึง": 15203,
 "านก": 15156,
 "ร้อ": 15031,
 "ค่อ": 15030,
 "นเล": 15027,
 "เลื": 14881,
 "รอบ": 14821,
 "องเ": 14674,
 "ถ้า": 14617,
 "งมา": 14519,
 "เคร": 14456,
 "บริ": 14365,
 "น่อ": 14307,
 "นกั": 14253,
 "ค้า": 14242,
 "หน่": 14164,
 "จะเ": 14082,
 "เดี": 14042,
 "เค้": 13999,
 "จาน": 13996,
 "ใหญ": 13860,
 "่ได": 13850,
 "หญ่": 13835,
 "ี่ย": 13809,
 "ากา": 13728,
 "้อย": 13544,
 "้อน": 13399,
 "่มี": 13200,
 "ิ้น": 13170,
 "ิกา": 13144,
 "หมื": 13072,
 "ลยค": 13068,
 "นไป": 13065,
 "ทอด": 13050,
 "ุ่ม": 13041,
 "นัก": 13027,
 "ยค่": 12994,
 "ใช้": 12971,
 "ไก่": 12936,
 "ดีย": 12923,
 "นิด": 12912,
 "มาเ": 12888,
 "ม่ไ": 12865,
 "ี้เ": 12851,
 "อร์": 12846,
 "ยมา": 12781,
 "ห้เ": 12712,
 "เดิ": 12610,
 "กาศ": 12592,
 "านม": 12474,
 "ครื": 12458,
 "งที": 12334,
 "็นร": 12330,
 "กระ": 12261,
 "กรอ": 12196,
 "นอา": 12076,
 "บรร": 12067,
 "ึ่ง": 12042,
 "ขนม": 11967,
 "รือ": 11947,
 "งาน": 11923,
 "ติด": 11895,
 "รยา": 11880,
 "านไ": 11762,
 "รรย": 11682,
 '"ร้': 11630,
 "เห็": 11620,
 "นข้": 11610,
 "หอม": 11607,
 "...": 11560,
 "าจะ": 11517,
 "ลูก": 11501,
 "้าม": 11485,
 "ตาม": 11464,
 "ลัง": 11310,
 "ะคะ": 11228,
 "ุ้ง": 11224,
 "สุด": 11191,
 "ชิ้": 11182,
 "องร": 11174,
 "ี่ส": 11152,
 "่งเ": 11151,
 "กมา": 11129,
 "ทุก": 11063,
 "ท่า": 11059,
 "านท": 11026,
 "ี้ย": 10827,
 "ื่น": 10812,
 "ออก": 10797,
 "รวม": 10774,
 "าไม": 10700,
 "าทา": 10659,
 "่าย": 10637,
 "บ้า": 10544,
 "ปิด": 10509,
 "าร้": 10507,
 "ผัด": 10476,
 "มาท": 10419,
 "ิ้ม": 10406,
 "กุ้": 10397,
 "ม่ค": 10367,
 "ากก": 10344,
 "นุ่": 10306,
 "ะนำ": 10256,
 "ดีค": 10251,
 "นได": 10217,
 "างเ": 10160,
 "หรื": 10119,
 "นะน": 10109,
 "ตั้": 10091,
 "ด้เ": 10067,
 "ไข่": 10054,
 "้าย": 10038,
 "เล็": 10034,
 "แนะ": 10026,
 "จัด": 9942,
 "จริ": 9940,
 "ล็ก": 9911,
 "รู้": 9909,
 "ดิน": 9819,
 "นก็": 9772,
 "้ได": 9744,
 "น้อ": 9682,
 "นั้": 9666,
 "ใส่": 9658,
 "ม่ม": 9654,
 "โดย": 9654,
 "่นี": 9640,
 "เย็": 9590,
 "ย็น": 9571,
 "ริง": 9544,
 "ำหร": 9487,
 "อยม": 9463,
 "บอก": 9459,
 "หรั": 9453,
 "ก็เ": 9447,
 "ต๊ะ": 9419,
 "ากๆ": 9361,
 "จ้า": 9322,
 "สำห": 9300,
 "าเป": 9263,
 "วยเ": 9239,
 "งไม": 9223,
 "าที": 9211,
 "ห็น": 9205,
 "มีเ": 9193,
 "นไม": 9161,
 "ต้ม": 9147,
 "เท่": 9137,
 "่าเ": 9130,
 "ม่แ": 9124,
 "นให": 9111,
 "องท": 9100,
 "กงา": 9096,
 "ตรง": 9082,
 "นอย": 9021,
 "อยา": 9011,
 "ก่อ": 9010,
 "จะม": 9010,
 "่ค่": 9009,
 "เปิ": 8985,
 "ตอน": 8981,
 "โต๊": 8973,
 "ะเป": 8972,
 "ชื่": 8923,
 "าขา": 8922,
 "ะมี": 8918,
 "ผัก": 8876,
 "าแฟ": 8860,
 "ักง": 8848,
 "กาแ": 8844,
 "านแ": 8833,
 "พนั": 8820,
 "จอด": 8817,
 "็นเ": 8795,
 "ก็ไ": 8777,
 "นเป": 8768,
 "ันเ": 8753,
 "ั่ว": 8708,
 "กกก": 8597,
 "นแล": 8485,
 "่าจ": 8467,
 "่มา": 8461,
 "อยเ": 8455,
 "้าเ": 8417,
 "ี่จ": 8416,
 "่าร": 8385,
 "่าไ": 8353,
 "มีท": 8348,
 "ส้น": 8346,
 "ี่ร": 8299,
 "นาน": 8260,
 "เอา": 8252,
 "ับร": 8235,
 "แพง": 8232,
 "เส้": 8216,
 "่วง": 8212,
 "ยดี": 8206,
 "เที": 8203,
 "มาร": 8200,
 "เอง": 8199,
 "างร": 8163,
 "้ยว": 8137,
 "อนเ": 8121,
 "สาข": 8102,
 "เต็": 8074,
 "้มา": 8051,
 "ต่อ": 8030,
 "ี่ม": 8012,
 "จิ้": 7998,
 "มาณ": 7958,
 "ี๋ย": 7945,
 "นตั": 7941,
 "๋ยว": 7915,
 "ี่ไ": 7906,
 "เรื": 7895,
 "ับเ": 7893,
 "ซุป": 7873,
 "นจะ": 7867,
 "อะไ": 7804,
 "้นเ": 7783,
 "เพิ": 7764,
 "อเค": 7759,
 "หมด": 7724,
 "มมา": 7721,
 "รีย": 7709,
 "่ไม": 7704,
 "ลาก": 7697,
 "งไป": 7635,
 "พิ่": 7629,
 "ินเ": 7600,
 "้าไ": 7592,
 "้งแ": 7590,
 "องด": 7579,
 "รีม": 7570,
 "หม่": 7520,
 "าไป": 7494,
 "านค": 7493,
 "ต่เ": 7493,
 "้อม": 7491,
 "งอย": 7487,
 "ในร": 7470,
 "อื่": 7435,
 "ขาย": 7417,
 "ดมา": 7405,
 "ช้ไ": 7400,
 "ด้า": 7400,
 "ั่น": 7383,
 "โอเ": 7383,
 "รั้": 7364,
 "ใคร": 7327,
 "กหล": 7320,
 "งเป": 7288,
 "ากิ": 7287,
 "อว่": 7273,
 "ินไ": 7265,
 "ารท": 7250,
 "งทา": 7235,
 "เตี": 7226,
 "แน่": 7213,
 "ระเ": 7201,
 "ะเล": 7175,
 "เมื": 7163,
 "ละเ": 7161,
 "ถือ": 7160,
 "อยด": 7148,
 "สาม": 7147,
 "ิงๆ": 7145,
 "บาง": 7132,
 "ะไร": 7121,
 "่ร้": 7116,
 "ใหม": 7110,
 "เพื": 7105,
 "๋วย": 7097,
 "ื่ม": 7089,
 "ียง": 7088,
 "ก๋ว": 7087,
 'ะ";': 7086,
 "พื่": 7086,
 "ดื่": 7080,
 "งดี": 7069,
 "ุ่น": 7057,
 "ถูก": 7055,
 "างๆ": 7032,
 "ยเต": 7032,
 "านี": 7032,
 "านใ": 7025,
 "อนข": 7020,
 "ไทย": 7006,
 "เด็": 6998,
 "ข้น": 6995,
 "ากค": 6986,
 "พร้": 6984,
 "งเล": 6968,
 "คุณ": 6959,
 "กลั": 6956,
 "ตี๋": 6922,
 "นอก": 6914,
 "องก": 6906,
 "ารเ": 6889,
 "หลั": 6883,
 "กลา": 6847,
 "ชิม": 6840,
 "นเด": 6830,
 "าก็": 6826,
 "ือว": 6805,
 "ริม": 6776,
 "องแ": 6764,
 "ก็ม": 6755,
 "ลาด": 6753,
 "ค้ก": 6751,
 "ยคร": 6733,
 "ี้ม": 6705,
 "แวะ": 6698,
 "อดร": 6694,
 "่เค": 6678,
 "ังไ": 6670,
 "ากเ": 6667,
 "อกเ": 6661,
 "ผ่า": 6628,
 "ากห": 6610,
 "เคย": 6578,
 "ต่า": 6556,
 "่ที": 6516,
 "นค่": 6495,
 "ากั": 6473,
 "ีค่": 6464,
 "ันไ": 6459,
 "กล้": 6453,
 "องห": 6453,
 "จะไ": 6452,
 "ราด": 6438,
 "ข้ม": 6417,
 "ำให": 6412,
 "ช่ว": 6408,
 "กที": 6388,
 "คิด": 6365,
 "ลาง": 6349,
 "านห": 6339,
 "มข้": 6337,
 "แรก": 6297,
 "ซอส": 6292,
 "เลี": 6276,
 "ภาพ": 6262,
 "ลับ": 6229,
 "ิ่ง": 6210,
 "ไปห": 6188,
 "อาจ": 6170,
 "ก็อ": 6167,
 "เกิ": 6164,
 "่เป": 6094,
 "านข": 6090,
 "นึง": 6090,
 "ซอย": 6085,
 "ายเ": 6084,
 "ลี่": 6068,
 "่ก็": 6037,
 "านจ": 6000,
 "เสี": 5997,
 "่อม": 5993,
 "เรี": 5990,
 "ายๆ": 5979,
 "ดรถ": 5976,
 "้ำจ": 5975,
 "นเย": 5971,
 "ถนน": 5970,
 "ีที": 5966,
 "บมา": 5965,
 "ต่ก": 5951,
 "านต": 5948,
 "ไปเ": 5945,
 "กแล": 5942,
 "บาย": 5938,
 "ิ่น": 5930,
 "ห้อ": 5929,
 "านั": 5928,
 "วลา": 5925,
 "ารอ": 5894,
 "เวล": 5891,
 "ียบ": 5884,
 "ึ้น": 5866,
 "เผ็": 5841,
 "ขึ้": 5839,
 "ม่อ": 5836,
 "ำจิ": 5833,
 "ผ็ด": 5832,
 "ี่อ": 5827,
 "นคร": 5821,
 "งมี": 5821,
 "ระม": 5807,
 "สีย": 5802,
 "่อร": 5796,
 "มกั": 5789,
 "ล่อ": 5767,
 "่ต้": 5758,
 "ะคร": 5753,
 "ไว้": 5751,
 "พริ": 5707,
 "องค": 5695,
 "รี่": 5694,
 "ู่ใ": 5686,
 "อนก": 5685,
 "นมี": 5678,
 "เขี": 5673,
 "รรม": 5666,
 "้เป": 5665,
 "เจ้": 5662,
 "ี่ป": 5637,
 "กอย": 5615,
 "เหน": 5614,
 "ต็ม": 5602,
 "งกั": 5584,
 "ส้ม": 5579,
 "่แพ": 5579,
 "ขีย": 5571,
 "้มข": 5564,
 "้าก": 5543,
 "ชั้": 5513,
 "มาน": 5512,
 "านส": 5510,
 "ูกค": 5504,
 "สบา": 5483,
 "นหน": 5472,
 "ต่ง": 5465,
 "ครี": 5465,
 "้งอ": 5462,
 "องส": 5457,
 "งจา": 5450,
 "ังเ": 5433,
 "ะไม": 5432,
 "งดื": 5431,
 "คนเ": 5430,
 "่ใน": 5412,
 "มีโ": 5400,
 "รัก": 5399,
 "ไปท": 5391,
 "ำลั": 5386,
 "ะอา": 5381,
 "น่น": 5377,
 "กลิ": 5376,
 "นีย": 5371,
 "กำล": 5364,
 "กค้": 5360,
 "กแต": 5359,
 "สลั": 5358,
 "ระท": 5356,
 "กเล": 5355,
 "าเล": 5326,
 "งอา": 5322,
 "่งม": 5320,
 "่เห": 5316,
 "วก็": 5316,
 "ธรร": 5301,
 "ยที": 5296,
 "็ไม": 5278,
 "นเม": 5278,
 "ซึ่": 5276,
 "ีมา": 5271,
 "งใน": 5259,
 "รุง": 5258,
 "สวย": 5253,
 "ลิ่": 5246,
 "ล่า": 5239,
 "านบ": 5237,
 "นใน": 5228,
 "ไส้": 5224,
 "แถว": 5215,
 "คุ้": 5214,
 "ลัด": 5212,
 "ือเ": 5196,
 "มาแ": 5189,
 "เปร": 5188,
 "นน้": 5181,
 "รที": 5164,
 "ติม": 5160,
 "ปรี": 5159,
 "เค็": 5158,
 "แค่": 5154,
 "อดี": 5146,
 "ควร": 5134,
 "ค่า": 5122,
 "็มี": 5120,
 "ไม้": 5089,
 "ิร์": 5088,
 "ค็ม": 5084,
 "ด้ค": 5072,
 "้ำซ": 5068,
 "ไปน": 5066,
 "หมา": 5060,
 "อยค": 5059,
 "้งเ": 5058,
 "เจอ": 5045,
 "่นั": 5045,
 "่าท": 5040,
 "องม": 5034,
 "้มี": 5026,
 "ี่แ": 5024,
 "ยนะ": 5022,
 "แกง": 5019,
 "นขอ": 4999,
 "่ยน": 4985,
 "ุ้ม": 4976,
 "เหล": 4975,
 "ทีเ": 4975,
 "ิดห": 4963,
 "่นเ": 4962,
 "ือง": 4957,
 "าเข": 4944,
 "มาล": 4943,
 "เปล": 4942,
 "มีค": 4932,
 "กค่": 4932,
 "มาใ": 4931,
 "้าร": 4929,
 "นกา": 4915,
 "สึก": 4912,
 "ามเ": 4905,
 "ทีย": 4899,
 "ูที": 4899,
 "ัดเ": 4894,
 "ู้ส": 4890,
 "นดี": 4887,
 "งก็": 4882,
 "เสร": 4881,
 "ามส": 4879,
 "บร้": 4875,
 "อะม": 4872,
 "งแต": 4863,
 "อยๆ": 4862,
 "่งท": 4861,
 "นเค": 4854,
 "ีเด": 4849,
 "ารั": 4839,
 "่จอ": 4828,
 "้สึ": 4826,
 "งให": 4824,
 "หนี": 4823,
 "ยวเ": 4822,
 "ันท": 4817,
 "าลอ": 4807,
 "าให": 4801,
 "อัน": 4799,
 "ิ้ง": 4795,
 "าหม": 4789,
 "องไ": 4789,
 "านด": 4780,
 "ารถ": 4779,
 "้วก": 4771,
 "ราเ": 4767,
 "บอร": 4763,
 "มกล": 4754,
 "วนต": 4747,
 "ทำใ": 4744,
 "หอย": 4740,
 "ด็ด": 4735,
 "รี้": 4733,
 "แก้": 4729,
 "ดีม": 4721,
 "ับค": 4720,
 "าขอ": 4709,
 "นึ่": 4708,
 "กคร": 4708,
 "ัวเ": 4705,
 "กล่": 4696,
 "มาต": 4691,
 "ข็ง": 4664,
 "ินท": 4663,
 "นูท": 4656,
 "ช้า": 4656,
 "ำซุ": 4650,
 "สอง": 4648,
 "หร่": 4647,
 "งเค": 4642,
 "ดยร": 4641,
 "ก็ต": 4640,
 "ม่ร": 4636,
 "วิว": 4636,
 "ี้อ": 4612,
 "่งก": 4603,
 "ต่ไ": 4592,
 "ซื้": 4590,
 "็กๆ": 4588,
 "แข็": 4577,
 "นทา": 4575,
 "ปหน": 4573,
 "ต่ร": 4557,
 "แดง": 4553,
 "่งไ": 4551,
 "็นส": 4542,
 "ายร": 4534,
 "้ไม": 4530,
 "นเก": 4524,
 "้อเ": 4521,
 "มี่": 4519,
 "มดา": 4510,
 "ปาก": 4509,
 "ี่ค": 4507,
 "ปัง": 4507,
 "โปร": 4505,
 '่ะ"': 4502,
 "ตกแ": 4497,
 "นแบ": 4494,
 "ไปก": 4485,
 "ก็จ": 4483,
 "ติอ": 4478,
 "งข้": 4456,
 "รมด": 4451,
 "ารด": 4445,
 "านร": 4442,
 "ียน": 4441,
 "าร์": 4440,
 "งสั": 4439,
 "้มย": 4434,
 "็อร": 4434,
 "ชีส": 4432,
 "ังด": 4430,
 "ี่ท": 4421,
 "ทะเ": 4417,
 "ป้ง": 4414,
 "ากท": 4405,
 "งหว": 4404,
 "ราว": 4402,
 "ากร": 4401,
 "แป้": 4400,
 "องอ": 4399,
 "ยรว": 4398,
 "อนๆ": 4384,
 "ม่ห": 4381,
 "็นอ": 4373,
 "ไอศ": 4353,
 "าไห": 4351,
 "งได": 4337,
 "นหม": 4332,
 "างท": 4326,
 "่ชอ": 4317,
 "พวก": 4298,
 "่สั": 4292,
 "มีก": 4290,
 "็นค": 4287,
 "เล่": 4286,
 "มีห": 4286,
 "าวห": 4254,
 "มปั": 4252,
 "ังม": 4246,
 "มยำ": 4245,
 "มีใ": 4241,
 "ี่ช": 4226,
 "ปุ่": 4223,
 "ี่ต": 4222,
 "มาะ": 4220,
 "วยค": 4220,
 "่เล": 4214,
 "ม่ต": 4212,
 "ากม": 4202,
 "็นก": 4200,
 "มอร": 4199,
 "่นๆ": 4198,
 "ี้ก": 4193,
 "่ปุ": 4192,
 "าได": 4191,
 "ญี่": 4190,
 "ี้ไ": 4188,
 "มที": 4181,
 "นเอ": 4179,
 "มีร": 4168,
 "งนี": 4166,
 "หนึ": 4163,
 "ช่น": 4154,
 "หมี": 4147,
 "พอด": 4138,
 "ม่ใ": 4130,
 "นอี": 4126,
 "นาด": 4125,
 "อยแ": 4122,
 "ลาเ": 4122,
 "กจา": 4120,
 "นมป": 4116,
 "ก้ว": 4114,
 "งแล": 4105,
 "ดหน": 4105,
 "รูป": 4103,
 "็นแ": 4102,
 "นเส": 4099,
 "งเด": 4097,
 "จจะ": 4084,
 "กร้": 4084,
 "ปรุ": 4071,
 "มื่": 4070,
 "งเย": 4066,
 "ราย": 4063,
 "งหม": 4057,
 "สะอ": 4044,
 "ีวิ": 4040,
 "ขนา": 4040,
 "รดี": 4036,
 "วนี": 4022,
 "ีให": 4014,
 "่เร": 4008,
 "ห้า": 4002,
 "ม่น": 4000,
 "ล้า": 3999,
 "ลอด": 3998,
 "่าอ": 3997,
 "ติเ": 3996,
 "ี้ค": 3995,
 "วัง": 3979,
 "าวเ": 3970,
 "ยอย": 3968,
 "ชาเ": 3963,
 "ระด": 3953,
 "กชิ": 3945,
 "ีทั": 3943,
 "อกม": 3937,
 "มาจ": 3935,
 "นด้": 3933,
 "ดเล": 3933,
 "งแร": 3931,
 "อกว": 3926,
 "งตั": 3923,
 "เช่": 3912,
 "อยก": 3907,
 "นใจ": 3907,
 "อิ่": 3906,
 "ติก": 3904,
 "กลม": 3903,
 "่งร": 3899,
 "งค่": 3897,
 "จะอ": 3893,
 "ายอ": 3891,
 "เบอ": 3890,
 "ปิ้": 3885,
 "งหน": 3883,
 "ดให": 3880,
 "นหล": 3880,
 "สิร": 3877,
 "มแล": 3871,
 "ไหร": 3856,
 "อยไ": 3849,
 "องจ": 3849,
 "่นอ": 3845,
 "มาย": 3838,
 "ร์ฟ": 3835,
 "เสิ": 3835,
 "ล่น": 3833,
 "งจะ": 3828,
 "่งอ": 3828,
 "ยวก": 3821,
 "งวั": 3820,
 "สัก": 3812,
 "้าข": 3808,
 "ก้อ": 3807,
 "่าม": 3806,
 "นเพ": 3805,
 "่าก": 3791,
 "อาด": 3787,
 "ินก": 3786,
 "หวั": 3785,
 "าจจ": 3775,
 "ง่า": 3770,
 "ในเ": 3769,
 "่น้": 3761,
 "ยเล": 3743,
 "ด้ม": 3742,
 "าเก": 3739,
 "ทั่": 3733,
 "างค": 3730,
 "ากน": 3725,
 "แถม": 3715,
 "ป็ด": 3712,
 "ับไ": 3706,
 "งกา": 3695,
 "ดว่": 3695,
 "ารไ": 3693,
 "ี่ก": 3692,
 "ิดเ": 3688,
 "นเร": 3680,
 "ายก": 3664,
 "่จะ": 3661,
 "ะเท": 3659,
 "ปทา": 3656,
 "าแล": 3656,
 "ายใ": 3645,
 "ารม": 3636,
 "อบเ": 3630,
 "ละก": 3629,
 "สเต": 3625,
 "งเม": 3624,
 "้ค่": 3624,
 "นรา": 3619,
 "่าค": 3618,
 "งเท": 3616,
 "วไป": 3615,
 "ม่ว": 3608,
 "อกจ": 3606,
 "คาไ": 3601,
 "ะหม": 3600,
 "ไหน": 3581,
 "กติ": 3578,
 "ใกล": 3578,
 "ารส": 3564,
 "ี่ห": 3564,
 "ะอย": 3563,
 "กหน": 3562,
 "่งแ": 3559,
 "ิมา": 3556,
 "็จะ": 3556,
 "อนน": 3553,
 "มีอ": 3550,
 "ต้น": 3549,
 "ับข": 3549,
 "ยไม": 3545,
 "วมา": 3545,
 "ุณภ": 3544,
 "ณภา": 3543,
 "าสั": 3542,
 "งน้": 3537,
 "้ำแ": 3532,
 "กทา": 3530,
 "ผิด": 3528,
 "รีว": 3521,
 "อกา": 3516,
 "นคน": 3514,
 "่งส": 3505,
 "งคร": 3504,
 "ีคร": 3498,
 "งกร": 3498,
 "นเข": 3497,
 "้าต": 3497,
 "ิดี": 3494,
 "หนั": 3488,
 "่รู": 3487,
 "ารก": 3484,
 "ชาม": 3482,
 "ู่ท": 3481,
 "วเล": 3477,
 "เกี": 3475,
 "ันค": 3471,
 "้งห": 3466,
 "ี่โ": 3466,
 "าะเ": 3464,
 "รมา": 3464,
 "่สุ": 3460,
 "งขอ": 3458,
 "มน้": 3453,
 "กกว": 3451,
 "ป้า": 3451,
 "อบท": 3450,
 "างน": 3447,
 "้มต": 3443,
 "มีแ": 3442,
 "ะค่": 3441,
 "ริ่": 3440,
 "ยไป": 3439,
 "นูน": 3436,
 "้าห": 3426,
 "้เร": 3424,
 "อกไ": 3421,
 "ียม": 3416,
 "ปนิ": 3413,
 "ารจ": 3411,
 "ลมก": 3407,
 "มค่": 3407,
 "งด้": 3403,
 "นนะ": 3401,
 "ดีเ": 3401,
 "ับก": 3397,
 "ารบ": 3394,
 "มคว": 3394,
 "บรา": 3390,
 "อยน": 3386,
 "ารต": 3386,
 "้าใ": 3384,
 "เริ": 3380,
 "้จะ": 3375,
 "้ก็": 3374,
 "ิดน": 3371,
 "อยท": 3367,
 "ดัง": 3362,
 "างแ": 3361,
 "่มเ": 3356,
 "ดหว": 3355,
 "อบอ": 3351,
 "นนั": 3350,
 "เพล": 3344,
 "เร็": 3342,
 "ซลม": 3341,
 "---": 3337,
 "ดิม": 3336,
 "ับป": 3334,
 "่นก": 3332,
 "นละ": 3330,
 "องน": 3326,
 "างก": 3324,
 "แม่": 3319,
 "ด้ท": 3318,
 "องช": 3317,
 "นบร": 3316,
 "ายม": 3315,
 "ับใ": 3312,
 "้วน": 3308,
 "าอย": 3307,
 "ราช": 3306,
 "ลัก": 3303,
 "ีเม": 3302,
 "ละค": 3301,
 "ียด": 3300,
 "่อเ": 3285,
 "ี๊ย": 3283,
 "แซล": 3283,
 "งเร": 3282,
 "โรง": 3274,
 "าจา": 3272,
 "็นต": 3250,
 "ารา": 3248,
 "มตำ": 3246,
 "นูเ": 3233,
 "่ทา": 3226,
 "ราก": 3226,
 "้งน": 3226,
 "วกั": 3226,
 "ามี": 3224,
 "วยน": 3216,
 "นเห": 3214,
 "แห้": 3212,
 "ะทั": 3211,
 "ก็ค": 3203,
 "ะเพ": 3198,
 "ห้ง": 3198,
 "รบร": 3186,
 "ี่ใ": 3186,
 "ินม": 3185,
 "้วเ": 3183,
 "งเก": 3181,
 "งเพ": 3178,
 "อบค": 3175,
 "ูกช": 3174,
 "นกล": 3169,
 "างอ": 3165,
 "อร้": 3160,
 "่ให": 3156,
 "คิว": 3154,
 "ันก": 3153,
 "พาะ": 3152,
 "าค่": 3152,
 "้ว่": 3147,
 "ปกต": 3144,
 "ลมอ": 3144,
 "ามอ": 3143,
 "พลา": 3135,
 "แปล": 3134,
 "ะได": 3129,
 "ุดๆ": 3117,
 "ด้อ": 3116,
 "อบม": 3115,
 "คู่": 3113,
 "้นท": 3111,
 "อ่อ": 3111,
 "ดน้": 3110,
 "งรส": 3109,
 "เขา": 3107,
 "รุป": 3104,
 "งชิ": 3101,
 "ัดไ": 3094,
 "้าอ": 3093,
 "มีข": 3086,
 "สไต": 3081,
 "้สั": 3079,
 'บ";': 3078,
 "ลยท": 3074,
 "าเม": 3074,
 "ร็ว": 3073,
 "ินแ": 3069,
 "ุกอ": 3067,
 "ละอ": 3067,
 "ะไป": 3066,
 "มาช": 3064,
 "นูอ": 3063,
 "ยวน": 3062,
 "ท้า": 3059,
 "รัว": 3057,
 "หาก": 3053,
 "ร์เ": 3053,
 "กให": 3052,
 "ียก": 3050,
 "ยใน": 3047,
 "สรุ": 3046,
 "่แล": 3044,
 "งเข": 3044,
 "ฟเฟ": 3043,
 "้ที": 3040,
 "จีน": 3040,
 "ะกั": 3038,
 "เน้": 3036,
 "ทับ": 3033,
 "ู่ต": 3024,
 "สริ": 3024,
 "มเล": 3017,
 "้าจ": 3015,
 "้งท": 3011,
 "ิดใ": 3008,
 "อนท": 3002,
 "่าแ": 3002,
 "้นม": 3001,
 "ับม": 3000,
 "มอน": 2999,
 "นเน": 2991,
 "าชิ": 2990,
 "อนแ": 2989,
 "อกห": 2988,
 "ยวห": 2987,
 "น้น": 2979,
 "็ได": 2978,
 "้ลอ": 2975,
 "แหล": 2974,
 "ดกั": 2972,
 "มูก": 2972,
 "หมึ": 2970,
 "อเป": 2970,
 "ระจ": 2967,
 "มึก": 2966,
 "อมก": 2964,
 "กไป": 2955,
 "ซ่บ": 2952,
 "ม่ถ": 2951,
 "ละม": 2950,
 "แซ่": 2947,
 "มาไ": 2945,
 "่เย": 2942,
 "อมา": 2942,
 "ัดก": 2942,
 "่ใช": 2939,
 "งกิ": 2938,
 "ับน": 2935,
 "ปริ": 2935,
 "ันด": 2935,
 "ดนึ": 2934,
 "ด้น": 2932,
 "บน้": 2932,
 "เชี": 2931,
 "มาด": 2929,
 "าเร": 2929,
 "ักเ": 2929,
 "ตล์": 2927,
 "ดาว": 2922,
 "แยก": 2921,
 "ารร": 2920,
 "ไตล": 2919,
 "เก็": 2919,
 "ชุด": 2916,
 "แอร": 2916,
 "นต้": 2914,
 "กได": 2912,
 "นอร": 2908,
 "นดู": 2903,
 "ิดว": 2903,
 "ด้แ": 2903,
 "วหน": 2903,
 "งแบ": 2899,
 "้มแ": 2898,
 "บที": 2897,
 "กน้": 2897,
 "ะทา": 2895,
 "สุก": 2894,
 "กไม": 2894,
 "นว่": 2894,
 "้นไ": 2892,
 "่าส": 2890,
 "ูนี": 2890,
 "าว่": 2884,
 "อสม": 2883,
 "งปร": 2877,
 "ตลอ": 2876,
 "คาร": 2874,
 "าตา": 2873,
 "่กั": 2872,
 "ยกว": 2871,
 "าเย": 2869,
 "็นห": 2863,
 "โอก": 2862,
 "บบน": 2862,
 "บบเ": 2862,
 "างม": 2858,
 "อรี": 2856,
 "ชีย": 2856,
 "ามค": 2855,
 "่หว": 2855,
 "ามร": 2854,
 "อบก": 2852,
 "บกั": 2852,
 "่ยว": 2851,
 "ด้ด": 2849,
 "วนเ": 2847,
 "เด่": 2844,
 "ารแ": 2843,
 "พูด": 2842,
 "ือบ": 2840,
 "หลื": 2837,
 "ก็ส": 2837,
 "รสเ": 2836,
 "าอร": 2835,
 "ายค": 2834,
 "้นห": 2833,
 "้าท": 2832,
 "มหว": 2824,
 "ชาด": 2823,
 'ับ"': 2822,
 "ับบ": 2822,
 "ซ่า": 2821,
 "้นใ": 2818,
 "ชั่": 2818,
 "ดเด": 2817,
 "ี้จ": 2817,
 "บไม": 2815,
 "คนท": 2814,
 "กจะ": 2812,
 "คาเ": 2812,
 "้นก": 2809,
 "หัว": 2809,
 "้ำเ": 2802,
 "้งก": 2800,
 "ด่น": 2800,
 "ะที": 2800,
 "่รส": 2789,
 "ิดๆ": 2789,
 "อหม": 2787,
 "มไป": 2782,
 "าหล": 2781,
 "มก็": 2780,
 "็นช": 2779,
 "กเม": 2776,
 "กรี": 2775,
 "้คร": 2773,
 "ดีก": 2772,
 "ด้ก": 2767,
 "้ทา": 2765,
 "มาอ": 2763,
 "ังก": 2754,
 "ันห": 2748,
 "ดิบ": 2748,
 "อไม": 2744,
 "ด้ไ": 2742,
 "านๆ": 2741,
 "ดที": 2741,
 "าท)": 2741,
 "กาส": 2737,
 "างไ": 2736,
 "แอบ": 2734,
 "วาง": 2733,
 "ถ้ว": 2730,
 "ดแล": 2727,
 "นทร": 2724,
 "ฟิน": 2723,
 "บใจ": 2721,
 "ีหล": 2720,
 "ลาห": 2718,
 "้ดี": 2715,
 "ต่ท": 2714,
 "บข้": 2713,
 "โกแ": 2709,
 "าด้": 2708,
 "อบน": 2707,
 "ใช่": 2699,
 "ลี้": 2696,
 "มูส": 2695,
 "้อไ": 2694,
 "ักก": 2690,
 "ถ่า": 2689,
 "โซน": 2688,
 "าเส": 2687,
 "บนี": 2686,
 "ู่ก": 2686,
 "ระห": 2684,
 "เศษ": 2683,
 "่ว่": 2681,
 "ะร้": 2675,
 "ูชิ": 2675,
 "ี้แ": 2675,
 "มีน": 2672,
 "อยส": 2671,
 "็นท": 2670,
 "องใ": 2658,
 "ละร": 2658,
 "ินอ": 2653,
 "กเป": 2648,
 "ด้ร": 2646,
 "มเป": 2645,
 "างส": 2637,
 "่ทอ": 2636,
 "วค่": 2636,
 "มีส": 2636,
 "าศร": 2634,
 'ย";': 2632,
 "ปล่": 2630,
 "งรอ": 2629,
 "ันอ": 2625,
 "้อร": 2622,
 "กใจ": 2621,
 "นอน": 2621,
 "เคี": 2621,
 "เต้": 2621,
 "เฉพ": 2618,
 "ละไ": 2617,
 "มสั": 2616,
 "งาม": 2614,
 "คาก": 2612,
 "ฉพา": 2612,
 "ขาน": 2611,
 "นไก": 2610,
 "ปลก": 2609,
 "อมเ": 2607,
 "เทศ": 2598,
 "กนั": 2591,
 "ก่ท": 2586,
 "านา": 2586,
 "าวน": 2583,
 "งทอ": 2575,
 "่พอ": 2573,
 "วไม": 2572,
 "อนไ": 2571,
 "ี้ต": 2566,
 "าใน": 2565,
 "ปกิ": 2564,
 "ยได": 2560,
 "ดไป": 2557,
 "ามห": 2550,
 "พัก": 2549,
 "่ยง": 2547,
 "องข": 2543,
 "รก็": 2541,
 "ำปล": 2540,
 "บะห": 2539,
 "กอร": 2538,
 "นเท": 2538,
 "ราม": 2537,
 "ดับ": 2537,
 "ต็ก": 2535,
 "บปร": 2534,
 "างด": 2533,
 "างใ": 2533,
 "นห้": 2529,
 "ตี้": 2529,
 "ยแล": 2527,
 "ลาท": 2520,
 "วผั": 2516,
 "้อป": 2513,
 "าตร": 2511,
 "บคร": 2510,
 "ึงเ": 2509,
 "นขน": 2509,
 "หม้": 2505,
 "องต": 2505,
 "ริฟ": 2504,
 "มื้": 2504,
 "แลต": 2504,
 "กี้": 2503,
 "่วไ": 2498,
 "แนว": 2493,
 "วหม": 2492,
 "ต้า": 2491,
 "วต้": 2491,
 "นตา": 2488,
 "ถั่": 2486,
 "นรส": 2483,
 "มาห": 2482,
 "้เย": 2480,
 "เช้": 2480,
 "าดน": 2479,
 "กรุ": 2476,
 "นหอ": 2476,
 "รอง": 2476,
 "วให": 2475,
 "ห้ม": 2474,
 "ับแ": 2473,
 "โดน": 2471,
 "นส่": 2467,
 "มไม": 2467,
 "นาว": 2461,
 "ากล": 2458,
 "ิเศ": 2452,
 "ลไม": 2451,
 "วที": 2451,
 "งเห": 2450,
 "าวม": 2448,
 "นปร": 2448,
 "ัดจ": 2444,
 "ลยไ": 2441,
 "นสั": 2441,
 "็นข": 2436,
 "พิเ": 2434,
 "้ำม": 2433,
 "ม่ก": 2430,
 "้ำต": 2429,
 "นแร": 2427,
 "ก็ย": 2427,
 "คนไ": 2424,
 "กหม": 2422,
 "เติ": 2420,
 "ับส": 2419,
 "สูง": 2417,
 "ะเห": 2414,
 "ช็อ": 2414,
 "ปลี": 2413,
 "้วค": 2410,
 "นำเ": 2407,
 "าอา": 2405,
 "กกิ": 2401,
 "ศร้": 2400,
 "มาค": 2399,
 "่ถ้": 2398,
 "่งต": 2398,
 "ห็ด": 2394,
 "ต่ค": 2389,
 "ครอ": 2389,
 "ากจ": 2387,
 "อนร": 2381,
 "ม่ส": 2378,
 "นปล": 2377,
 "าวผ": 2372,
 "ขวา": 2368,
 "านล": 2365,
 "ดกร": 2364,
 "นวั": 2364,
 "ราไ": 2362,
 "ีโอ": 2360,
 "ันม": 2360,
 "นอื": 2360,
 "หละ": 2360,
 "่หม": 2355,
 "ายด": 2354,
 "าเห": 2353,
 "ต่ถ": 2353,
 "่งข": 2352,
 "ด้ล": 2352,
 "่อไ": 2350,
 "ากไ": 2349,
 "ับอ": 2348,
 "บกา": 2348,
 "นชา": 2348,
 "็นไ": 2345,
 "าอี": 2345,
 "ยร้": 2343,
 "รถเ": 2343,
 "บทา": 2343,
 "อยจ": 2342,
 "างห": 2341,
 "ังค": 2341,
 "รงข": 2341,
 "าะก": 2340,
 "ยิ่": 2340,
 "ตลา": 2339,
 "ำแข": 2337,
 "ันแ": 2335,
 "่งน": 2332,
 "ภาย": 2332,
 "มูแ": 2330,
 "ยกั": 2329,
 "ดไม": 2329,
 "ู่แ": 2329,
 "๊ยว": 2327,
 "ูกร": 2323,
 "ี้ท": 2322,
 "านป": 2321,
 "ังจ": 2320,
 "่ไป": 2317,
 "เฟ่": 2317,
 "ผสม": 2317,
 "งกล": 2315,
 "ราส": 2314,
 "ม้อ": 2309,
 "นสา": 2308,
 "ีกว": 2308,
 "างจ": 2307,
 "สมค": 2307,
 "คล้": 2303,
 "ถาม": 2301,
 "งหล": 2299,
 "อติ": 2297,
 "ฟรี": 2296,
 "สะด": 2294,
 "เกา": 2293,
 "นัง": 2291,
 "ดร้": 2288,
 "ขับ": 2287,
 "เซ็": 2286,
 "ๆค่": 2286,
 "ผลไ": 2281,
 "าคร": 2280,
 "ะนา": 2279,
 "ายท": 2279,
 "อกท": 2278,
 "ยด้": 2278,
 "ต่ล": 2276,
 "บุฟ": 2274,
 "นแน": 2274,
 "ายไ": 2273,
 "้มค": 2270,
 "นสุ": 2269,
 "ไปอ": 2269,
 "นจา": 2267,
 "ฐาน": 2264,
 "อยอ": 2264,
 "องป": 2259,
 "่ดี": 2258,
 "ุฟเ": 2258,
 "่มม": 2258,
 "พอส": 2252,
 "เก่": 2246,
 "บคน": 2244,
 "มีไ": 2238,
 "วะม": 2235,
 "นซอ": 2235,
 "ะดู": 2233,
 "้อก": 2233,
 "องล": 2232,
 "ศคร": 2232,
 "โคร": 2231,
 "้นะ": 2230,
 "ดอร": 2228,
 "้อแ": 2226,
 "ี้ส": 2225,
 "อกล": 2225,
 "จะต": 2224,
 "่นม": 2221,
 "ุกค": 2220,
 "ากแ": 2217,
 "งอร": 2216,
 "จืด": 2216,
 "าดี": 2216,
 "ปั่": 2213,
 "้รส": 2213,
 "ยกา": 2211,
 "กด้": 2211,
 "พระ": 2209,
 "ท้อ": 2208,
 "นื่": 2207,
 "่เข": 2205,
 "วงเ": 2201,
 "็เล": 2197,
 "ังส": 2197,
 "มรส": 2196,
 "อะเ": 2194,
 "ม่ท": 2194,
 "อศค": 2189,
 "่งค": 2186,
 "ี่ผ": 2185,
 "่งช": 2185,
 "่แน": 2182,
 "้งส": 2180,
 "คาว": 2178,
 "ักษ": 2177,
 "ด้ส": 2176,
 "ับท": 2176,
 "่งด": 2173,
 "ายแ": 2172,
 "มาถ": 2171,
 "วมั": 2170,
 "ใจเ": 2169,
 "กกั": 2167,
 "กก็": 2166,
 "ลิ้": 2162,
 "มดี": 2162,
 "ะน้": 2162,
 "งใจ": 2160,
 "มะน": 2158,
 "ักท": 2153,
 "าปร": 2153,
 "อ่ะ": 2152,
 "งคน": 2152,
 "ฝั่": 2151,
 "่ตั": 2150,
 "นน่": 2150,
 "งนั": 2149,
 "ะดี": 2144,
 "กี๊": 2144,
 "่ละ": 2144,
 "ก็แ": 2142,
 "วนใ": 2142,
 "ักห": 2142,
 "นแต": 2137,
 "มให": 2135,
 "ึกว": 2135,
 "ินค": 2134,
 "ะเอ": 2133,
 "ยว่": 2132,
 "มรา": 2131,
 "ีนะ": 2130,
 "ีน้": 2127,
 "มอง": 2127,
 "เกื": 2126,
 "มร้": 2122,
 "กือ": 2122,
 "้ำส": 2122,
 "ครา": 2122,
 "ต่ส": 2119,
 "สัง": 2117,
 "ก่า": 2117,
 "าเท": 2116,
 "างข": 2113,
 "ต่พ": 2113,
 "ครง": 2112,
 "อดม": 2112,
 "ำมา": 2111,
 "องบ": 2111,
 "ะรา": 2111,
 "อกน": 2109,
 "้อห": 2108,
 "ม่ผ": 2106,
 "สุข": 2106,
 "ยเห": 2102,
 "างว": 2101,
 "งนะ": 2099,
 "ารใ": 2099,
 "ีเล": 2098,
 "วร้": 2098,
 "นกร": 2094,
 "ลยเ": 2093,
 "าเต": 2093,
 "าศด": 2092,
 "ไปแ": 2092,
 "้กร": 2092,
 "ียร": 2091,
 "้ำป": 2088,
 "ูกใ": 2085,
 "ด็ก": 2083,
 "ปเล": 2081,
 "าเด": 2076,
 "ีกร": 2076,
 "ยก็": 2076,
 "งเน": 2073,
 "้บร": 2073,
 "นขา": 2072,
 "ญ่ม": 2072,
 "ะแน": 2070,
 "!!!": 2070,
 "จะส": 2069,
 "เบี": 2069,
 "ะเข": 2066,
 "หิว": 2065,
 "ม่ช": 2065,
 "ดูก": 2062,
 "บีย": 2062,
 "อดก": 2059,
 "เฉย": 2059,
 "มเค": 2057,
 "ละน": 2057,
 "สับ": 2054,
 "่รา": 2052,
 "ซ้า": 2051,
 "ีคว": 2049,
 "้ด้": 2048,
 "ุงเ": 2047,
 "รงแ": 2047,
 "ในห": 2046,
 "มาส": 2046,
 "ยเป": 2046,
 "วแล": 2042,
 "ยรู": 2041,
 "สปา": 2040,
 "้าแ": 2038,
 "ต่ม": 2034,
 "อกร": 2031,
 "ล่ะ": 2030,
 "่หน": 2029,
 "ี่ด": 2028,
 "ๆเล": 2028,
 "าถึ": 2027,
 "ร็จ": 2026,
 "นยั": 2026,
 "บ่อ": 2024,
 "ี่บ": 2023,
 "ละส": 2023,
 "ก็โ": 2020,
 "ะจำ": 2019,
 "เบา": 2019,
 "องโ": 2019,
 "มว่": 2018,
 "็ยั": 2017,
 "งคื": 2012,
 "โมง": 2011,
 "าทำ": 2011,
 "ไปค": 2010,
 "ายส": 2010,
 "ว้า": 2009,
 "ากใ": 2008,
 "ยาว": 2007,
 "ทอง": 2006,
 "ยขอ": 2005,
 "วเห": 2005,
 "ต่ว": 2004,
 "่นแ": 2002,
 "ดก็": 2002,
 "เกล": 2002,
 "่งใ": 2001,
 "ศกร": 1998,
 "่ติ": 1997,
 "ครบ": 1996,
 "าวต": 1995,
 '"เป': 1994,
 "่ตร": 1994,
 "มะม": 1994,
 "เกต": 1993,
 "บไป": 1993,
 "้มเ": 1992,
 "ทำไ": 1992,
 "นก๋": 1990,
 "ะเค": 1990,
 "ตตี": 1989,
 "ปาเ": 1989,
 "ตุ๋": 1986,
 "ะหว": 1985,
 "อศก": 1983,
 "ุ๋น": 1982,
 "ะม่": 1980,
 "ดดี": 1979,
 "ยยย": 1978,
 "ข่เ": 1977,
 "พี่": 1975,
 "ห้ค": 1974,
 "ติไ": 1971,
 "จนเ": 1971,
 "ศดี": 1971,
 "หล่": 1970,
 "รอร": 1970,
 "่ด้": 1968,
 "ดีน": 1966,
 "่เด": 1965,
 "าะส": 1964,
 "ัดม": 1964,
 "ี้น": 1964,
 "นทั": 1960,
 "อบแ": 1958,
 "่น่": 1958,
 "นอะ": 1957,
 "ก็บ": 1955,
 "ing": 1953,
 "าชอ": 1953,
 "้าค": 1952,
 "งชา": 1952,
 "ซูช": 1949,
 "ตอร": 1948,
 "งรา": 1946,
 "ก็ร": 1945,
 "นถึ": 1944,
 "าแบ": 1943,
 "่มก": 1940,
 "ยาม": 1939,
 "าพร": 1938,
 "บบไ": 1938,
 "เพี": 1935,
 "ดได": 1934,
 "ยสั": 1933,
 "ารค": 1931,
 "ุ้น": 1931,
 "นมเ": 1928,
 "นชื": 1926,
 "านช": 1925,
 "นมจ": 1923,
 "นนอ": 1922,
 "พลิ": 1922,
 "มถน": 1921,
 "ในก": 1921,
 "้กิ": 1920,
 "้งใ": 1919,
 "ไปด": 1917,
 "ดยเ": 1916,
 "ลืม": 1914,
 "อยใ": 1914,
 "้ตั": 1913,
 "กนิ": 1912,
 "อนม": 1912,
 "วัด": 1911,
 "***": 1911,
 "่สำ": 1909,
 "รไม": 1909,
 "่งห": 1909,
 "ต่ต": 1907,
 "ิดก": 1906,
 "สวน": 1904,
 "งต้": 1904,
 "ๆกั": 1904,
 "จึง": 1903,
 "ซีฟ": 1901,
 "าดเ": 1899,
 "นิ่": 1899,
 "ห้ไ": 1899,
 "่คร": 1898,
 "าดห": 1897,
 "ยร์": 1895,
 "ำไม": 1895,
 "ดจ้": 1895,
 "็นว": 1895,
 "่สา": 1893,
 "่เส": 1891,
 "ตัด": 1891,
 "นชอ": 1890,
 "อเบ": 1889,
 "อกแ": 1889,
 "ีฟู": 1889,
 "ูแล": 1889,
 "อจะ": 1888,
 "ุดท": 1886,
 "ลิน": 1884,
 "ะสั": 1883,
 "ามก": 1881,
 "มัก": 1879,
 "ละแ": 1878,
 "หาย": 1873,
 "ไอต": 1873,
 "ดท้": 1873,
 "ฉยๆ": 1872,
 "ีกล": 1870,
 "นเต": 1865,
 "าตั": 1864,
 "้ไป": 1862,
 "มได": 1860,
 "ี่ข": 1860,
 "ดใจ": 1859,
 "้มก": 1858,
 "บรส": 1857,
 "่มอ": 1856,
 "ยบก": 1855,
 "้งไ": 1854,
 "มขอ": 1854,
 "นนิ": 1853,
 "ยคะ": 1853,
 "นต่": 1853,
 "ละห": 1851,
 '"วั': 1851,
 "่ปร": 1849,
 "พีย": 1849,
 "อคโ": 1848,
 "านโ": 1848,
 "ฟมา": 1845,
 "นูแ": 1843,
 "ับผ": 1837,
 "ดวก": 1836,
 "ู่บ": 1835,
 "ก็น": 1833,
 "งดู": 1833,
 "จะแ": 1833,
 "่มแ": 1831,
 "ากอ": 1831,
 "อเท": 1831,
 "ิอร": 1830,
 "ดขอ": 1829,
 "ซี่": 1828,
 "กคน": 1828,
 'น";': 1828,
 "กโก": 1826,
 "มาพ": 1824,
 "ะดั": 1822,
 "มจี": 1820,
 "ึงร": 1820,
 "ดูเ": 1819,
 "ามม": 1819,
 "ะดว": 1818,
 "ละข": 1817,
 "ิอา": 1816,
 "ยอด": 1815,
 "บบ้": 1815,
 "ผู้": 1815,
 "จมา": 1814,
 "ีกแ": 1814,
 "มีป": 1814,
 "รั่": 1814,
 "นบ้": 1812,
 "ดค่": 1808,
 "ำมั": 1807,
 "้นแ": 1806,
 "ในซ": 1805,
 "่เน": 1804,
 "อดเ": 1803,
 "่ชั": 1803,
 "มเห": 1801,
 "่คน": 1801,
 "อนค": 1800,
 "ก็ด": 1798,
 "กัด": 1797,
 "ใจม": 1796,
 "หนา": 1796,
 "ชาบ": 1795,
 "ด้ง": 1794,
 "รอก": 1793,
 "าวก": 1790,
 "บเล": 1787,
 "มด้": 1786,
 "อบๆ": 1784,
 "สร็": 1784,
 "คโก": 1782,
 "ะพร": 1782,
 "่เจ": 1782,
 "รฐา": 1781,
 "ี้ร": 1781,
 "าวแ": 1780,
 "มชั": 1778,
 "นคู": 1778,
 "าบู": 1778,
 "ตรฐ": 1777,
 "ทำเ": 1777,
 "ือจ": 1777,
 "แรม": 1775,
 "็นม": 1774,
 "วยก": 1774,
 "เกอ": 1773,
 "าดด": 1773,
 "ลวก": 1772,
 "วคร": 1771,
 "้าส": 1770,
 "กวั": 1769,
 "ำเป": 1767,
 "นำใ": 1766,
 "ะว่": 1765,
 "่ถู": 1764,
 "่าใ": 1763,
 "่ทำ": 1763,
 "ามท": 1761,
 "้นอ": 1761,
 "ื้น": 1760,
 "ักส": 1759,
 "ีรส": 1758,
 "จะท": 1753,
 "ๆๆๆ": 1753,
 "้ให": 1753,
 "ดีท": 1752,
 "เตอ": 1752,
 "มีพ": 1750,
 "สถา": 1750,
 "กแน": 1750,
 "ึงก": 1749,
 "ลยส": 1746,
 "าเพ": 1745,
 "อได": 1745,
 "มุม": 1744,
 "อาก": 1743,
 "จอร": 1743,
 "มสด": 1742,
 "็โอ": 1740,
 "ูอา": 1739,
 "ุดเ": 1739,
 "ยิ้": 1739,
 "พอใ": 1738,
 "ังห": 1737,
 "ุกเ": 1737,
 "ยเฉ": 1737,
 "าเน": 1736,
 "ยเม": 1736,
 "ู่เ": 1735,
 "เนี": 1735,
 "the": 1734,
 "ูแด": 1733,
 "ในต": 1731,
 "้กั": 1729,
 "ฝรั": 1729,
 "าเค": 1727,
 "แรง": 1727,
 "กี่": 1726,
 "งหา": 1726,
 "าต้": 1725,
 "มูย": 1722,
 "กเค": 1722,
 "องพ": 1721,
 "ปลอ": 1717,
 "แม้": 1716,
 "่ผม": 1715,
 "ายห": 1715,
 "ยวไ": 1713,
 "่กร": 1713,
 "ในส": 1713,
 "งเอ": 1708,
 "่ยั": 1707,
 "ลาส": 1706,
 "่อค": 1705,
 "อมม": 1704,
 "ลยว": 1703,
 "็เป": 1703,
 "เผา": 1701,
 "รถไ": 1701,
 "แก่": 1700,
 "่นใ": 1699,
 "ันต": 1699,
 "้เค": 1699,
 "ะหน": 1697,
 "นึก": 1697,
 "รงเ": 1695,
 "อยห": 1695,
 "ดเร": 1694,
 "ู้จ": 1692,
 "่คว": 1692,
 "ะให": 1691,
 "ถาน": 1691,
 "้นๆ": 1690,
 "ีอา": 1687,
 "คอน": 1685,
 "ันส": 1684,
 "่บ้": 1684,
 "ิมถ": 1683,
 "กดี": 1682,
 "ไปล": 1682,
 "านย": 1679,
 "่ออ": 1677,
 "ูตร": 1676,
 "ลาน": 1674,
 "อาร": 1674,
 "าะม": 1674,
 "ับห": 1673,
 "้แล": 1673,
 "สาย": 1671,
 "มอย": 1670,
 "อัด": 1670,
 "่ผิ": 1670,
 "ๆก็": 1670,
 "ห่อ": 1669,
 "ีสา": 1668,
 "ากส": 1667,
 "่าต": 1667,
 "ยมี": 1666,
 "สาร": 1665,
 "ขาว": 1665,
 "ัดผ": 1664,
 "ีกห": 1663,
 "่นา": 1661,
 "ำเล": 1660,
 "้นค": 1659,
 "วเป": 1659,
 "อบร": 1657,
 "ลาแ": 1657,
 "านพ": 1656,
 "ลยน": 1655,
 "ข้อ": 1654,
 "ไปส": 1653,
 "ีกเ": 1653,
 "กะท": 1652,
 "นโต": 1649,
 "นเช": 1648,
 "งคว": 1646,
 "บเก": 1644,
 "รอย": 1644,
 "ม่พ": 1642,
 "จัง": 1639,
 "ัวใ": 1638,
 "วัต": 1638,
 "ลยล": 1638,
 "หรี": 1637,
 "ยงา": 1636,
 "เงิ": 1635,
 "สูต": 1635,
 "ามั": 1634,
 "ดด้": 1634,
 "อนส": 1633,
 "นมั": 1633,
 "ดอย": 1632,
 "่ไห": 1631,
 "อเด": 1629,
 "นาม": 1629,
 "ัดแ": 1629,
 "งเส": 1628,
 "นกิ": 1626,
 "สัน": 1624,
 "นรั": 1624,
 "พื้": 1623,
 "่อา": 1622,
 "อ่า": 1620,
 "ายต": 1618,
 "ละท": 1617,
 "ิเว": 1617,
 "ทัน": 1616,
 "่งจ": 1616,
 "จะห": 1615,
 "ีร้": 1614,
 "บกร": 1614,
 "ซัก": 1613,
 "ิดม": 1613,
 "ยี่": 1612,
 "บบร": 1611,
 "งว่": 1610,
 "นทำ": 1610,
 "ะทะ": 1609,
 "นชิ": 1609,
 "ก้า": 1609,
 "้าป": 1607,
 "ระก": 1607,
 "่ข้": 1607,
 "คะแ": 1606,
 "กเย": 1606,
 "้เห": 1605,
 "ำคั": 1605,
 "ร์ต": 1605,
 "จะก": 1603,
 "ดถึ": 1603,
 "้าด": 1602,
 "่นท": 1602,
 "ะอร": 1601,
 "นตร": 1600,
 "คัญ": 1599,
 "ะต้": 1599,
 "นคื": 1599,
 "นตก": 1598,
 "and": 1598,
 "งิน": 1598,
 "อบส": 1597,
 "พิซ": 1596,
 "ิซซ": 1595,
 "ี่พ": 1595,
 "ก็ห": 1595,
 "ตาล": 1595,
 "สำค": 1593,
 "้นน": 1593,
 "จะร": 1593,
 "้ำพ": 1593,
 "นเซ": 1593,
 "่วย": 1592,
 "ๆที": 1591,
 "กว้": 1589,
 "บเป": 1589,
 "ันจ": 1588,
 "่ยม": 1588,
 "ือไ": 1586,
 "ังน": 1586,
 "จุด": 1586,
 "้วแ": 1585,
 "บหม": 1584,
 "เจี": 1584,
 "่กล": 1584,
 "หว่": 1583,
 "่เก": 1583,
 "่ขอ": 1581,
 "่มใ": 1580,
 "อคิ": 1579,
 "่ถึ": 1578,
 "่กิ": 1578,
 "จะใ": 1577,
 "้จั": 1577,
 "ยทา": 1576,
 "ม่ย": 1576,
 "ืออ": 1573,
 "ร์ร": 1573,
 "กปา": 1573,
 "ีไม": 1571,
 "็อค": 1571,
 "มเน": 1571,
 "ินข": 1571,
 "ห้ด": 1570,
 '"มา': 1569,
 "ะเน": 1567,
 "ิก็": 1567,
 "ลยจ": 1567,
 "คาแ": 1565,
 "ู้ด": 1565,
 "ลงต": 1563,
 "อเล": 1562,
 "นคว": 1561,
 "ินส": 1558,
 "ารน": 1558,
 "ดูแ": 1557,
 "ใต้": 1556,
 "มีม": 1556,
 "ก็ถ": 1555,
 "้อส": 1555,
 "าใจ": 1552,
 "่อก": 1551,
 "ซซ่": 1551,
 "ีกา": 1548,
 "ห้น": 1547,
 "ไปไ": 1547,
 "ิดท": 1547,
 "าคุ": 1545,
 "วเอ": 1545,
 "ีคน": 1544,
 "้นส": 1544,
 "ด้ต": 1542,
 "ปด้": 1542,
 "ยวม": 1541,
 "่นห": 1541,
 "ลุก": 1540,
 "กเท": 1539,
 "ะหร": 1539,
 "เมล": 1539,
 "นมห": 1539,
 "่มๆ": 1539,
 "าาา": 1536,
 "ะรส": 1536,
 "ัวร": 1535,
 "ขอบ": 1532,
 "ูสั": 1532,
 "อนุ": 1531,
 "นทุ": 1531,
 "่ใจ": 1529,
 "ไปจ": 1529,
 "ู่ห": 1528,
 "ร่า": 1527,
 "กรา": 1527,
 "เนย": 1525,
 "ามแ": 1523,
 "็นๆ": 1519,
 "ับต": 1519,
 "านิ": 1519,
 "ีแต": 1519,
 "้งต": 1519,
 "งสด": 1516,
 'ๆ";': 1514,
 "ติจ": 1513,
 "ะนั": 1512,
 "บเพ": 1512,
 "ยวค": 1512,
 "่เม": 1511,
 "ุปเ": 1511,
 "งสา": 1510,
 "วนข": 1509,
 "็นน": 1508,
 "็นพ": 1508,
 "ปรั": 1508,
 "ุดิ": 1506,
 "สมา": 1504,
 "ลยแ": 1501,
 "ยให": 1500,
 "็ดม": 1500,
 "อนจ": 1500,
 "หลี": 1499,
 "าบา": 1499,
 "จัก": 1499,
 "ถุด": 1498,
 "็ต้": 1497,
 "นเจ": 1496,
 "จะด": 1496,
 "อกก": 1496,
 "่หล": 1496,
 "บว่": 1494,
 "ปเป": 1494,
 "็ดเ": 1494,
 "บอา": 1494,
 "้เพ": 1493,
 "ัตถ": 1492,
 "ังอ": 1492,
 "อทา": 1491,
 "ตถุ": 1490,
 'า";': 1489,
 "กหว": 1488,
 "แทบ": 1488,
 "งลอ": 1488,
 "ินร": 1487,
 "นแก": 1487,
 "็นป": 1485,
 "อไป": 1485,
 "้งค": 1484,
 "มีบ": 1484,
 "อนอ": 1483,
 "ริเ": 1483,
 "นผั": 1483,
 "นสว": 1483,
 "นด์": 1481,
 'คะ"': 1481,
 "ามช": 1481,
 "ถวน": 1479,
 "ต่น": 1478,
 "คับ": 1477,
 "่มั": 1477,
 "กเห": 1476,
 "จ่า": 1476,
 "งกะ": 1475,
 "บรถ": 1475,
 "อแน": 1474,
 "ิไม": 1474,
 "ปแล": 1473,
 "รจา": 1473,
 "าโอ": 1472,
 "งแว": 1472,
 "พอเ": 1471,
 "ยลอ": 1471,
 "็กน": 1471,
 "้วไ": 1470,
 "่ใส": 1469,
 "ปอี": 1469,
 "อาเ": 1467,
 "ไปต": 1464,
 "ยต้": 1464,
 "าน้": 1463,
 "ี้ข": 1463,
 "ือด": 1462,
 "้มม": 1461,
 "งแอ": 1461,
 "แนน": 1460,
 "คีย": 1457,
 "ต่ข": 1456,
 "บลู": 1455,
 "งกว": 1455,
 "ไกล": 1455,
 "อปล": 1454,
 "ามพ": 1454,
 "่มไ": 1453,
 "ติแ": 1453,
 "ยคว": 1453,
 "่นค": 1451,
 "งสบ": 1451,
 "ี้ห": 1451,
 "สาน": 1449,
 "่าห": 1448,
 "ลยต": 1448,
 "เวณ": 1447,
 "ักม": 1447,
 "นกว": 1446,
 "บเม": 1446,
 "าะร": 1444,
 "มูท": 1444,
 "บกิ": 1444,
 "ยใช": 1442,
 "ะกิ": 1442,
 "ดมั": 1442,
 "่วั": 1442,
 "้นป": 1441,
 "ำได": 1439,
 "้นจ": 1438,
 "วยง": 1438,
 "ก็ใ": 1437,
 "ครึ": 1436,
 "าวส": 1436,
 "าดไ": 1435,
 "ตึก": 1435,
 "อาท": 1434,
 "ก็พ": 1434,
 "ีโต": 1434,
 "ัดส": 1432,
 "ะวั": 1431,
 "กเก": 1430,
 "ละล": 1430,
 "ter": 1430,
 'ง";': 1429,
 "ลล์": 1428,
 "อที": 1427,
 "นตอ": 1426,
 "วจะ": 1425,
 "้ออ": 1424,
 "ลาบ": 1423,
 "่แห": 1423,
 "งพอ": 1422,
 "สี่": 1422,
 "วเร": 1422,
 "มัย": 1421,
 "มชา": 1419,
 "กต่": 1419,
 "มมี": 1419,
 "อดไ": 1418,
 "มใน": 1416,
 "ตรี": 1415,
 "ะก็": 1415,
 "้นล": 1415,
 "ึงค": 1414,
 "กแบ": 1414,
 "มีช": 1413,
 "หมั": 1412,
 "อมน": 1410,
 "่เพ": 1410,
 "วแต": 1409,
 "ยวแ": 1408,
 "ี่ล": 1405,
 "่โด": 1404,
 "้ำย": 1403,
 "ดจา": 1403,
 "ินต": 1402,
 "่าว": 1401,
 "กสด": 1401,
 "ห้ร": 1401,
 "รไท": 1400,
 "ดเป": 1400,
 "ารห": 1399,
 "มเย": 1398,
 "ฟู้": 1398,
 "ๆไป": 1398,
 "นนน": 1397,
 "อสั": 1395,
 "ุกี": 1395,
 "เชื": 1394,
 "่นไ": 1394,
 "ิกล": 1394,
 "องว": 1394,
 "มชอ": 1393,
 "ยสุ": 1393,
 "ายข": 1393,
 "มะพ": 1392,
 "ามน": 1392,
 "รเล": 1391,
 "่าล": 1390,
 "าวร": 1390,
 "าลา": 1390,
 "างล": 1390,
 "รงก": 1389,
 "ห้ท": 1389,
 "ยตั": 1388,
 "บาๆ": 1387,
 "าหน": 1386,
 "สาว": 1385,
 "ิดต": 1384,
 "ายน": 1384,
 "ดผั": 1384,
 "็มา": 1383,
 "อนา": 1383,
 "ับว": 1381,
 "นช่": 1381,
 "างช": 1379,
 "ดนี": 1379,
 "าดก": 1379,
 "าใช": 1378,
 "อให": 1376,
 "วีย": 1376,
 "ูกป": 1375,
 "รญี": 1374,
 "าดู": 1374,
 "าน่": 1374,
 "ือร": 1373,
 "รีบ": 1373,
 "ูน่": 1371,
 "ดูน": 1371,
 "ารญ": 1370,
 "ี้ผ": 1368,
 "เวี": 1368,
 "บเค": 1368,
 "่มท": 1367,
 "ะเก": 1365,
 "ไปถ": 1365,
 "อใช": 1364,
 "วอร": 1364,
 "่าโ": 1362,
 "าคน": 1362,
 "ยแต": 1361,
 "่ยา": 1361,
 "รทะ": 1361,
 "ขาห": 1360,
 "ยทุ": 1359,
 "มุน": 1359,
 "้น้": 1358,
 "ๆแล": 1358,
 "ตัก": 1356,
 "้นั": 1356,
 "เดอ": 1355,
 "านะ": 1355,
 "กไก": 1355,
 "็นโ": 1355,
 "งขว": 1354,
 "นกุ": 1354,
 "งเช": 1353,
 "ยเข": 1353,
 "้หม": 1352,
 "ดูด": 1352,
 "าเจ": 1350,
 "่มร": 1350,
 "้งม": 1349,
 "ต่จ": 1349,
 "คอย": 1348,
 "๊ะเ": 1346,
}
